import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { BodyRepairSection } from './components/BodyRepairSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FooterSection } from './components/FooterSection';
import { useExternalScript } from './hooks/useExternalScript';
const BINOTEL_GETCALL_SRC = 'https://widgets.binotel.com/getcall/widgets/96bnfdxdlw4s3r6lnwoa.js';
const BINOTEL_CALLTRACKING_SRC = 'https://widgets.binotel.com/calltracking/widgets/0puqr2lpi2z4o77bqwvp.js';
export function App() {
  useExternalScript(BINOTEL_GETCALL_SRC);
  useExternalScript(BINOTEL_CALLTRACKING_SRC);
  return <main className="bg-zinc-950 min-h-screen" data-id="element-0" data-mp="2wi5pxq64f1t0">
      <HeroSection data-id="element-1" data-mp="28te3zgj4jfoo" />
      <ServicesSection data-id="element-2" data-mp="28sl3gxardmez" />
      <BodyRepairSection data-id="element-3" data-mp="28s2z1ddy01vz" />
      <TestimonialsSection data-id="element-4" data-mp="23vuq4hqc94x9" />
      <AboutSection data-id="element-5" data-mp="23ujlygszdv5m" />
      <FooterSection data-id="element-6" data-mp="23v2uj6wqr76z" />
    </main>;
}